import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { Snackbar, Alert } from '@mui/material';

// ----------------------------------------------------------------------

SnackbarNotification.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  message: PropTypes.string,
  projectId: PropTypes.string
};

export default function SnackbarNotification({ open, handleClose, message,projectId }) { 
  const [isExisting, setIsExisting] = useState(false);
  const isProjectInBasket = (projectId) =>{
    const projectsInBasket = JSON.parse(window.localStorage.getItem('donate-projects'));    
    if(!projectsInBasket){
      return false;
    }        
    return (projectsInBasket.find(p=>p._id === projectId) !== undefined); 
  }
  
  useEffect(()=>{    
    setIsExisting(isProjectInBasket(projectId))
  },[open])

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      onClose={handleClose}
      message={message}
      autoHideDuration={5000}
      sx={{ top: '75px !important'}}
    >
      <Alert
        onClose={handleClose}
        variant="outlined"
        severity="success"
        sx={{ width: '100%' }}
      >
        {(isExisting)?'Project already in basket.':message}
      </Alert>
    </Snackbar>
  );
}
